export const COLORS = {
  white: '#FFFFFF',
  black: '#212120',
  orange: '#F96302',
};

export const ORANGE_CTA_BTN_CLASSES = 'sui-btn-primary-focus sui-btn-primary-active sui-btn-primary-hover';
export const BLACK_CTA_BTN_CLASSES = 'sui-bg-inverse sui-text-inverse hover:sui-bg-primary hover:sui-text-primary';
export const WHITE_CTA_BTN_CLASSES = 'sui-bg-primary sui-text-primary hover:sui-bg-inverse hover:sui-text-inverse';
